// PE-22 K3.4 — the "Nota" chip's write: SetRowDraft.notesPerCell[weekIdx].
// Split into its own file rather than added to programEditActions.ts, which
// was already at 494/500 lines (the 500-line cap) before this action — a
// pure extraction of one more `(draft, …) => Draft` action, same shape and
// same reuse of the exported `updateSlot`, no behaviour change to anything
// already in that file.
import { updateSlot } from "./programEditActions.js";
import type { Draft } from "./programEdit.js";

/** PE-37 — the per-EXERCISE note (`SlotDraft.instructions`), the thing the
 *  logger shows as the entry's 💬. One per slot, where `notesPerCell` is one
 *  per week cell: different fact, different write, deliberately next to each
 *  other so the pair is read together.
 *
 *  ⛔ Does NOT touch `instructionsRaw`. That is the lossless companion holding
 *  the other locales, and it is reconciled at SAVE by `graft` — exactly as
 *  `updateSetRowNote` leaves `notesRawPerCell` alone. Writing it here would
 *  mean deciding, on every keystroke, whether the coach is editing a
 *  translation or replacing it.
 */
export const updateSlotInstructions = (
  draft: Draft,
  sIdx: number,
  slotIdx: number,
  text: string,
): Draft =>
  draft.sessions[sIdx]?.slots[slotIdx]
    ? updateSlot(draft, sIdx, slotIdx, { instructions: text })
    : draft;

export const updateSetRowNote = (
  draft: Draft,
  sIdx: number,
  slotIdx: number,
  rowIdx: number,
  weekIdx: number,
  text: string,
): Draft => {
  const slot = draft.sessions[sIdx]?.slots[slotIdx];
  const row = slot?.setRows[rowIdx];
  if (!slot || !row) return draft;
  return updateSlot(draft, sIdx, slotIdx, {
    setRows: slot.setRows.map((r, i) =>
      i === rowIdx
        ? {
            ...r,
            notesPerCell: r.notesPerCell.map((n, w) =>
              w === weekIdx ? text : n,
            ),
          }
        : r,
    ),
  });
};
